<div
  class="sidenav"
  fxLayout="column"
>
  <div
    class="sidenav-toolbar mat-elevation-z1"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <div
      [routerLink]="['/dashboards/machines']"
      class="sidenav-toolbar-icon logo-image"
    >
      <i
        id="eclipse-icon"
        class="icon icon-brightness-3"
      ></i>
    </div>
    <div
      [routerLink]="['/dashboards/machines']"
      class="sidenav-toolbar-logo logo-text"
    >
      ECLIPSE PRO
    </div>

    <span fxFlex><!-- fill space --></span>

    <div
      fxFlexAlign="center"
      fxHide
      fxShow.gt-sm
      fxLayout="row"
    >
      <button
        (click)="toggleCollapsed()"
        class="sidenav-toolbar-collapse-toggle"
        class="s-40-btn burger-btn"
        mat-icon-button
      >
        <mat-icon
          fontSet="icomoon"
          fontIcon="icon-backburger"
          class="burgerIcon"
          [class.rotate-180]="collapsed"
        ></mat-icon>
      </button>
    </div>
  </div>
  <div class="plant-name">
    <span>{{ systemPreferences.plantName }}</span>
  </div>

  <fury-scrollbar class="sidenav-items">
    @for (item of items$ | async; track $index) {
    <fury-sidenav-item
      [item]="item"
      [level]="0"
    ></fury-sidenav-item>
    }
  </fury-scrollbar>

  <div class="server-version-container">
    <div>
      <span translate="serverVersion"></span>: {{ systemInfo.version }}
      @if (versionComparison < 0) {
      <span>*</span>
      }
    </div>
    @if (versionComparison > 0) {
    <button
      mat-button
      class="update-btn"
      translate="updateAvailable"
      routerLink="/settings/update"
    ></button>
    }
  </div>
</div>
